"use strict";
var table = document.querySelector(".field tbody");
var appendRow = document.querySelector(".append-row");
var removeRow = document.querySelector(".remove-row");
var appendColumn = document.querySelector(".append-column");
var removeColumn = document.querySelector(".remove-column");
var MAX = 10;
var MIN = 2;
function makeButtonDisabled(buttonElement) {
    buttonElement.disabled = true;
}
function makeButtonEnabled(buttonElement) {
    buttonElement.disabled = false;
}
appendRow.addEventListener("click", function() {
    if (table.rows.length === MIN) makeButtonEnabled(removeRow);
    if (table.rows.length === MAX) return;
    var newRow = document.createElement("tr");
    for(var i = 0; i < table.rows[0].cells.length; i++)newRow.appendChild(document.createElement("td"));
    table.appendChild(newRow);
    if (table.rows.length >= MAX) makeButtonDisabled(appendRow);
});
removeRow.addEventListener("click", function() {
    if (table.rows.length === MIN + 1) makeButtonDisabled(removeRow);
    table.rows[table.rows.length - 1].remove();
    if (table.rows.length <= MAX) makeButtonEnabled(appendRow);
});
appendColumn.addEventListener("click", function() {
    if (table.rows[0].cells.length >= MAX) return;
    if (table.rows[0].cells.length === MIN) makeButtonEnabled(removeColumn);
    for(var i = 0; i < table.rows.length; i++){
        var td = document.createElement("td");
        table.rows[i].appendChild(td);
    }
    if (table.rows[0].cells.length >= MAX) makeButtonDisabled(appendColumn);
});
removeColumn.addEventListener("click", function() {
    if (table.rows[0].cells.length === MIN + 1) makeButtonDisabled(removeColumn);
    if (table.rows[0].cells.length <= MIN) return;
    for(var i = 0; i < table.rows.length; i++)table.rows[i].cells[table.rows[i].cells.length - 1].remove();
    if (table.rows[0].cells.length <= MAX) makeButtonEnabled(appendColumn);
});

//# sourceMappingURL=index.db4ee06f.js.map
